import { Link } from 'react-router-dom';
import { films } from '@/mocks/films';

const stats = [
  { value: `${films.length}+`, label: '精选影视作品' },
  { value: '11', label: '覆盖类型题材' },
  { value: '6', label: '国家与地区' },
  { value: '每日', label: '资讯与片单更新' },
];

export default function IntroSection() {
  return (
    <section className="mx-auto w-full max-w-portal px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-8 rounded-lg border border-background-200 bg-primary-50/70 p-6 md:grid-cols-12 md:p-10">
        <div className="md:col-span-7">
          <span className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
            <span className="h-2 w-2 rounded-full bg-accent-500" />
            About Qingqingcao
          </span>
          <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            把找片这件事，做得更简单一点
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600">
            青青草围绕电影与电视剧整理结构化的作品资料：谁导的、谁演的、属于什么类型、适合什么时候看。
            你可以按类型、地区、年份层层筛选，也可以在详情页顺着标签找到气质相近的下一部。
          </p>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-500">
            我们不提供播放与下载，只做内容的整理与推荐。所有作品信息均为演示数据，用于呈现平台的使用方式。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              了解青青草
            </Link>
            <Link
              to="/category?type=tv&sort=rating"
              className="cursor-pointer whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm text-primary-700 transition-colors hover:bg-primary-100"
            >
              看看高分剧集
            </Link>
          </div>
        </div>
        <div className="md:col-span-5">
          <div className="grid grid-cols-2 gap-3">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200 bg-background-50 px-4 py-5"
              >
                <p className="font-heading text-2xl font-bold text-primary-700">{stat.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}